import { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { adminApi, setToken } from "@/utils/adminApi";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminTourEditor from "@/pages/AdminTourEditor";

export default function AdminApp() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const key = params.get("key");

    const tryKeyLogin = async (rawKey) => {
      try {
        const { data } = await adminApi.get(`/api/auth/key-login?code=${encodeURIComponent(rawKey)}`);
        setToken(data.token);
        setUser(data);
        navigate("/admin/dashboard", { replace: true });
        return true;
      } catch {
        return false;
      }
    };

    const verifyExistingSession = async () => {
      try {
        const r = await adminApi.get("/api/auth/me");
        setUser(r.data);
      } catch {
        // not logged in - login form will show
      }
    };

    (async () => {
      let loggedIn = false;
      if (key) loggedIn = await tryKeyLogin(key);
      if (!loggedIn) await verifyExistingSession();
      setChecking(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Auto-redirect to dashboard once user is set and we're at /admin (no sub-route)
  useEffect(() => {
    if (user && location.pathname === "/admin") {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [user, location.pathname, navigate]);

  if (checking) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <p className="text-white/40 font-sans text-sm">Loading...</p>
      </div>
    );
  }

  if (!user) return <AdminLogin onLogin={setUser} />;

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
      <Route path="/dashboard" element={<AdminDashboard />} />
      <Route path="/tours/:tourId" element={<AdminTourEditor />} />
      <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
    </Routes>
  );
}
